import { Injectable } from "@angular/core";
import { MotivoEncerramento } from "@tivic-team/manager-ts/dist/mob/entities/ait/motivo-encerramento.entity";
import { MotivoEncerramentoController } from "app/controllers/mob/motivo-encerramento-ait.controller";
import { LoaderService } from "../loader.service";
import { MotivoEncerramentoSearch } from "./motivo-encerramento.search";
import { ApiService } from "../api-service.interface";

@Injectable()
export class MotivoEncerramentoServices implements ApiService<MotivoEncerramento>{
    constructor(
        private _motivoEncerramentoController: MotivoEncerramentoController,
        private _loaderService: LoaderService
    ) {  }

    async find(ocorrenciaSearch?: MotivoEncerramentoSearch): Promise<MotivoEncerramento[]> {
        this._loaderService.show();
        return this._motivoEncerramentoController.find(ocorrenciaSearch && ocorrenciaSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }

    async save(motivoEncerramento: MotivoEncerramento): Promise<MotivoEncerramento> {
        console.log('Loading Tipo Arquivo Service...');
        this._loaderService.show();

        if (motivoEncerramento.cdMotivoEncerramento && motivoEncerramento.cdMotivoEncerramento > 0) {
            console.log('update');
            return this._motivoEncerramentoController.update(motivoEncerramento).finally(() => this._loaderService.hide());
        } else {
            console.log('create');
            return this._motivoEncerramentoController.create(motivoEncerramento).finally(() => this._loaderService.hide());
        }
    }

    async get(cdMotivoEncerramento: number): Promise<MotivoEncerramento> {
        this._loaderService.show();
        return this._motivoEncerramentoController.get(cdMotivoEncerramento).finally(() => this._loaderService.hide());
    }

    async create(entity: MotivoEncerramento): Promise<MotivoEncerramento> {
        throw new Error("Method not implemented");
    }

    update(entity: MotivoEncerramento): Promise<MotivoEncerramento> {
        throw new Error("Method not implemented");
    }
}